<script lang="ts">
	import { Tooltip } from '@repo/ui'

	interface Props {
		checked: boolean
		name: string
		label?: string
		tooltip?: string
		description?: string
		activeColor?: string
		inactiveColor?: string
		loading?: boolean
		noBottomMargin?: boolean
		children?: import('svelte').Snippet
		onChange?: (checked: boolean) => void
	}

	let {
		checked = $bindable(),
		name,
		label = '',
		tooltip = '',
		description = '',
		activeColor = 'bg-primary-500',
		inactiveColor = 'bg-gray-200 dark:bg-gray-600/70',
		loading = false,
		noBottomMargin = false,
		children,
		onChange,
	}: Props = $props()
</script>

<div class="relative">
	<input
		id={name}
		{name}
		class="peer pointer-events-none absolute top-3 right-0 opacity-0"
		onchange={() => {
			onChange?.(checked)
		}}
		type="checkbox"
		bind:checked
	/>
	<label
		class="flex cursor-pointer items-center justify-between gap-2 rounded-xs outline-gray-500 peer-focus-visible:outline"
		for={name}
	>
		{#if label}
			<span>
				<span class="flex items-center gap-1 text-base font-bold dark:text-white">
					{label}

					{#if tooltip}
						<Tooltip>
							{tooltip}
						</Tooltip>
					{/if}
				</span>
				{#if description}
					<span class="block text-xs">
						{description}
					</span>
				{/if}
			</span>
		{:else}
			{@render children?.()}
		{/if}
		<span
			class="flex h-6 w-11 shrink-0 rounded-full p-0.5 {checked ? `${activeColor}` : inactiveColor}"
		>
			<span
				class="
          relative block h-5 w-5 rounded-full bg-white p-px shadow transition-transform {checked
					? 'translate-x-5'
					: ''}"
			>
				{#if loading}
					<span
						class="
              block h-full w-full animate-spin rounded-full border-2 border-b-transparent transition-none
              {checked ? 'border-primary-500' : 'border-gray-500'}"
					></span>
				{/if}
			</span></span
		></label
	>
</div>

{#if !noBottomMargin}
	<div class="mt-5"></div>
{/if}
